// extracted by mini-css-extract-plugin
module.exports = {"text":"_3_donationInfo_text_3qQe2","checkBoxRadioWrap":"_3_donationInfo_checkBoxRadioWrap_1MC2k"};